import React from 'react';
import './RadioButton.scss';
const RadioButton = (props) => {
  const { action, title, name, id, checked, value } = props;
  return (
    // <div className="radio-button">
    //   <input
    //     type="radio"
    //     name={name}
    //     id={id}
    //     checked={checked}
    //     value={value}
    //     onClick={action}
    //   />
    //   <label for={id}>{title}</label>
    // </div>
    
    <div className="radio-button">
      <label className="radio-bring" key={id}>
        <input
          className="input-bring"
          type="radio"
          name={name}
          id={id}
          checked={checked}
          value={value}
          onClick={action}
        />
        <span>{title}</span>
      </label>
    </div>
  );
};

export default RadioButton;
